<script>
  import {onDestroy, onMount} from "svelte"
  import FetchOperationTableData
    from "../../../components/pages/projects/[project]/fetchers/FetchOperationTableData.svelte";
  import OperationTable from "./OperationTable.svelte";
  import { connectSearchParamsToOperationTableStore, initOperationTableStore } from "./OperationTableStore.js";
  import { connectOperationTableConfigurationToOperationTableStore } from "./OperationTableConfigurationStorage.js";

  export let projectId
  export let user

  const OperationTableStore = initOperationTableStore()

  let cleanups = []
  onMount(async () => {
    // the following functions subscribes the store, which must be cleaned up when the component gets unmounted.
    cleanups = [
      await connectOperationTableConfigurationToOperationTableStore(OperationTableStore, user?.id, projectId),
      connectSearchParamsToOperationTableStore(OperationTableStore),
    ].flat()
  })
  onDestroy(() => {
    for (const cleanup of cleanups) {
      cleanup()
    }
  })
</script>

<FetchOperationTableData
  projectId={projectId}
  refetchInterval={10000}
  {OperationTableStore}
  let:styles
  let:transactions
  let:reloadTransactions
  let:isInputAllowed
  let:operationsData
  let:propertyDefsData
>
  <OperationTable
    user={user}
    projectId={projectId}
    reloadTransactions={reloadTransactions}
    transactions={transactions}
    isInputAllowed={isInputAllowed}
    styles={styles}
    operationsData={operationsData}
    propertyDefsData={propertyDefsData}
    {OperationTableStore}
  />
</FetchOperationTableData>
